import { ReactNode } from "react";

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className={ClassName.container}>
      <span className={ClassName.title}>{title}</span>
      {description ? (
        <span className={ClassName.description}>{description}</span>
      ) : null}
      {action}
    </div>
  );
}

export default EmptyState;

const ClassName = {
  container:
    "flex min-h-36 w-full flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-slate-200 bg-slate-50 px-5 py-8 text-center",
  title: "text-sm font-semibold text-primaryText",
  description: "max-w-md text-xs leading-5 text-secondaryText",
};
